export const CHANGE_SEARCHFIELD = 'CHANGE_SEARCHFIELD';
export const ADD_ROBOT = 'ADD-ROBOT';
export const ADD_FIRSTNAME = 'UPDATE_FIRSTNAME';
export const ADD_LASTNAME = 'UPDATE_LASTNAME';
export const ADD_EMAIL = 'UPDATE_EMAIL';
export const GET_DATA = 'GET_DATA';